import { type TransactionDetailsResponseDTO } from '@capsicum/common';

import { useUserTransactionHistoryByTransactionIdQuery } from '../data-access/queries';

export const useTransactionCancellationData = (transactionId: string) => {
	const { data } = useUserTransactionHistoryByTransactionIdQuery(transactionId);

	const transactionDetails = data as unknown as TransactionDetailsResponseDTO | undefined;
	const isCancellable = !!transactionDetails?.extraMetadata?.isCancellableMarketPlace;
	const orderId: string | undefined = transactionDetails?.extraMetadata?.buyOrderId;

	return {
		isCancellable,
		orderId
	};
};
